/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCatalog200ResponseModifiersInner
 */
export interface GetCatalog200ResponseModifiersInner {
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseModifiersInner
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetCatalog200ResponseModifiersInner
     */
    priceImpact: number;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseModifiersInner
     */
    catalogId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCatalog200ResponseModifiersInner
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseModifiersInner
     */
    modifierGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseModifiersInner
     */
    organizationModifierId: string;
}

/**
 * Check if a given object implements the GetCatalog200ResponseModifiersInner interface.
 */
export function instanceOfGetCatalog200ResponseModifiersInner(value: object): value is GetCatalog200ResponseModifiersInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('priceImpact' in value) || value['priceImpact'] === undefined) return false;
    if (!('catalogId' in value) || value['catalogId'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('modifierGroupId' in value) || value['modifierGroupId'] === undefined) return false;
    if (!('organizationModifierId' in value) || value['organizationModifierId'] === undefined) return false;
    return true;
}

export function GetCatalog200ResponseModifiersInnerFromJSON(json: any): GetCatalog200ResponseModifiersInner {
    return GetCatalog200ResponseModifiersInnerFromJSONTyped(json, false);
}

export function GetCatalog200ResponseModifiersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalog200ResponseModifiersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'priceImpact': json['priceImpact'],
        'catalogId': json['catalogId'],
        'enabled': json['enabled'],
        'modifierGroupId': json['modifierGroupId'],
        'organizationModifierId': json['organizationModifierId'],
    };
}

export function GetCatalog200ResponseModifiersInnerToJSON(json: any): GetCatalog200ResponseModifiersInner {
    return GetCatalog200ResponseModifiersInnerToJSONTyped(json, false);
}

export function GetCatalog200ResponseModifiersInnerToJSONTyped(value?: GetCatalog200ResponseModifiersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'priceImpact': value['priceImpact'],
        'catalogId': value['catalogId'],
        'enabled': value['enabled'],
        'modifierGroupId': value['modifierGroupId'],
        'organizationModifierId': value['organizationModifierId'],
    };
}

